import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ModeloDocumentoDados } from '../modelo-documento.model'
import { ModeloDocumentoService } from '../modelo-documento.service'

interface LinhaPcd {
  inscricao: string
  nome: string
  classificacao: string
}

@Component({
  selector: 'app-form-retificacao-aprovados-pcd',
  templateUrl: './form-retificacao-aprovados-pcd.component.html',
  styleUrls: ['./form-retificacao-aprovados-pcd.component.scss'],
})
export class FormRetificacaoAprovadosPcdComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  @Input() concursoId!: number
  @Output() formData = new EventEmitter<Record<string, string>>()

  dados?: ModeloDocumentoDados
  campos: Record<string, string> = {}
  linhas: LinhaPcd[] = []

  constructor(private service: ModeloDocumentoService) {}

  ngOnInit(): void {
    this.service.obterDados(this.concursoId, 'RETIFICACAO_APROVADOS_PCD')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: d => {
          this.dados = d
          this.campos = { ...d.camposEditaveis }
          this.linhas = this.montarLinhas(d.camposEditaveis)
          this.serializar()
          this.emitir()
        },
        error: () => this.dados = undefined
      })
  }

  private montarLinhas(campos: Record<string, string>): LinhaPcd[] {
    const count = Number(campos['pcd_count'] || '0')
    const linhas: LinhaPcd[] = []
    for (let i = 0; i < count; i++) {
      linhas.push({
        inscricao: campos[`pcd_${i}_inscricao`] || '',
        nome: campos[`pcd_${i}_nome`] || '',
        classificacao: campos[`pcd_${i}_classificacao`] || '',
      })
    }
    return linhas
  }

  private serializar(): void {
    // Remove chaves pcd_* antigas antes de re-serializar
    for (const k of Object.keys(this.campos)) {
      if (k.startsWith('pcd_')) delete this.campos[k]
    }
    this.campos['pcd_count'] = String(this.linhas.length)
    this.linhas.forEach((l, i) => {
      this.campos[`pcd_${i}_inscricao`] = l.inscricao
      this.campos[`pcd_${i}_nome`] = l.nome
      this.campos[`pcd_${i}_classificacao`] = l.classificacao
    })
  }

  onLinhaChange(): void {
    this.serializar()
    this.emitir()
  }

  adicionarLinha(): void {
    this.linhas.push({ inscricao: '', nome: '', classificacao: '' })
    this.onLinhaChange()
  }

  removerLinha(index: number): void {
    this.linhas.splice(index, 1)
    this.onLinhaChange()
  }

  onCampoChange(key: string, value: string): void {
    this.campos[key] = value ?? ''
    this.emitir()
  }

  emitir(): void {
    this.formData.emit(this.campos)
  }
}
